import React from "react";
import Form from "../contact/contactForm";

export default ({ data, privacy, theme }) => {
  return <Form data={data} privacy={privacy} theme={theme} />;
};
